<template>
  <div>
    <b-overlay :show="$store.state.isLoadingPriData" rounded="sm">
      <b-navbar-nav class="ml-auto">
        <h3>Configurable PRI's</h3>
      </b-navbar-nav>
      <b-navbar toggleable="lg" variant="light">
        <b-navbar-brand href="#">Predictive Risk Indicators</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-button
              @click="onAddPriModalClick"
              size="sm"
              class="my-2 my-sm-0"
              variant="outline-primary"
              type="button"
            >Add</b-button>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <b-table
        class="mx-1"
        bordered
        sticky-header="calc(100vh - 200px)"
        ref="table"
        id="my-table"
        :busy.sync="$store.state.isLoadingPriData"
        :items="$store.state.allPriItems"
        :fields="fieldsPrIList"
        responsive="sm"
      >
        <template v-slot:cell(title)="data">{{data.item.title ? data.item.title : null}}</template>
        <template v-slot:cell(status)="data">
          <b-badge v-if="data.item.status == '1'" variant="warning">Draft</b-badge>
          <b-badge v-if="data.item.status == '2'" variant="success">Active</b-badge>
          <b-badge v-if="data.item.status == '3'" variant="danger">Expired</b-badge>
        </template>
        <template v-slot:cell(actions)="data">
          <b-btn
            v-if="data.item.status == '1'"
            size="sm"
            class="mr-2"
            @click="makeDefaultPri(data)"
            variant="outline-warning"
          >Set as Default</b-btn>
          <b-btn
            v-if="data.item.status == '2' && data.item.is_platform_default == '0'"
            size="sm"
            class="mr-2"
            @click="activeDeactivePri(data)"
            variant="outline-danger"
          >Deactivate</b-btn>
          <b-btn
            v-if="data.item.status == '1'"
            class="mr-2"
            @click="onEditPriModalClick(data)"
            variant="outline-info"
            size="sm"
          >
            <font-awesome-icon icon="edit"></font-awesome-icon>
          </b-btn>
          <b-btn
            v-if="data.item.is_platform_default == '1' || data.item.status == '3'"
            class="mr-2"
            @click="onViewPriModalClick(data)"
            variant="outline-info"
            size="sm"
          >
            <font-awesome-icon icon="eye"></font-awesome-icon>
          </b-btn>
          <b-btn
            class="mr-2"
            @click="onDuplicatePriModalClick(data)"
            variant="outline-warning"
            size="sm"
          >
            <font-awesome-icon icon="copy"></font-awesome-icon>
          </b-btn>
        </template>
      </b-table>
    </b-overlay>
    <b-overlay :show="showActiveDeactivePri" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
          <font-awesome-icon size="lg" icon="cloud-upload-alt" />
          <div class="mb-3">Deactivating...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure?</strong>
          </p>
          <div class="d-flex">
            <b-button
              variant="outline-success"
              class="mr-3"
              @click="resetActiveDeactivePriModal"
            >Cancel</b-button>
            <b-button variant="outline-danger" @click="activeDeactivePriCall">Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
    <b-overlay :show="showMakeDefaultPri" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
          <font-awesome-icon size="lg" icon="cloud-upload-alt" />
          <div class="mb-3">Making Default Pri.....</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong
              id="form-confirm-label"
            >Are you sure to make this pri default it will make pri as default and the current configration will no longer be active?</strong>
          </p>
          <div class="d-flex justify-content-center">
            <b-button
              variant="outline-success"
              class="mr-3"
              @click="resetMakeDefaultPriModal"
            >Cancel</b-button>
            <b-button variant="outline-danger" @click="makeDefaultPriCall">Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
    <AddPriComponent :platformPriSettings="true" :clientPriSettings="false" />
  </div>
</template>
<script>
import { HTTP } from "../../utils/HTTP";
import AddPriComponent from "../../components/Pri/addPriModal/addPriModal.vue";
import { EventBus } from "@/event-bus.js";
import { Helper } from "../../helpers";
export default {
  name: "PriSettingsConfigurablePri",
  components: {
    AddPriComponent
  },
  data() {
    return {
      processing: false,
      counter: 1,
      interval: null,
      priId: null,
      priStatus: null,
      showMakeDefaultPri: false,
      showActiveDeactivePri: false,
      fieldsPrIList: [
        { key: "id", label: "id", sortable: true },
        { key: "created_at", label: "Age", sortable: true },
        { key: "created_by.name", label: "Creator", sortable: true },
        { key: "title", label: "Title", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "pri_categories.name", label: "Categories", sortable: true },
        { key: "actions", sortable: false }
      ]
    };
  },
  mounted() {
    this.getAllPriData();
  },
  beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    async getAllPriData() {
      this.$store.state.isLoadingPriData = true;
      let token = "Bearer " + localStorage.getItem("accessToken");

      try {
        let result = await HTTP(
          "get",
          "v1/pri/all",
          null,
          {
            Authorization: token
          },
          null,
          true
        );

        this.$store.state.allPriItems = result.data.pri;
        this.$store.state.isLoadingPriData = false;
      } catch {
        this.$store.state.isLoadingPriData = false;
      }
    },
    activeDeactivePri(data) {
      this.priId = data.item.id;
      this.priStatus = data.item.status;
      this.showActiveDeactivePri = true;
    },
    activeDeactivePriCall() {
      this.counter = 1;
      this.processing = true;
      this.deactivePriApiCall().then(this.getAllPriData);
      this.clearInterval();
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick(() => {
            this.resetActiveDeactivePriModal();
          });
        }
      }, 200);
    },
    async deactivePriApiCall() {
      let formData = {
        pri_version_id: this.priId,
        status: 1
      };
      try {
        let result = await HTTP("post", "v1/deactive-pri", formData);
        this.priId = null;
        if (result.data.success == 2) {
          Helper.makeToast(this.$bvToast, "danger", result.data.message);
          this.priId = null;
        }
      } catch (err) {
        this.priId = null;
        return [err];
      }
    },
    resetActiveDeactivePriModal() {
      this.priId = null;
      this.priStatus = null;
      this.processing = false;
      this.showActiveDeactivePri = false;
    },
    makeDefaultPri(data) {
      this.priId = data.item.id;
      this.showMakeDefaultPri = true;
    },
    resetMakeDefaultPriModal() {
      this.priId = null;
      this.processing = false;
      this.showMakeDefaultPri = false;
    },
    makeDefaultPriCall() {
      this.counter = 1;
      this.processing = true;
      this.makeDefaultPriApiCall().then(this.getAllPriData);
      this.clearInterval();
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick(() => {
            this.resetMakeDefaultPriModal();
          });
        }
      }, 200);
    },
    async makeDefaultPriApiCall() {
      let formData = {
        pri_version_id: this.priId,
        status: 2,
        is_platform_default: 1
      };
      try {
        await HTTP("post", "v1/make-default-pri", formData);
      } catch (err) {
        this.priId = null;
        return [err];
      }
    },
    onAddPriModalClick() {
      EventBus.$emit("onShowAddModal", "");
    },
    onEditPriModalClick(selectedPri) {
      EventBus.$emit("onShowEditModal", selectedPri);
    },
    onDuplicatePriModalClick(selectedPri) {
      EventBus.$emit("onShowDuplicateModal", selectedPri);
    },
    onViewPriModalClick(selectedPri) {
      EventBus.$emit("onShowViewPriModal", selectedPri);
    }
  }
};
</script>